import React, { useState } from 'react'
import { Button } from '@lana-ui/common'
import { NewsletterCardItem, ErrorSection } from '@lana-ui/arc'

export const NewslettersForm = ({ newsletters, selectedOptions, toggleSelectAll, handleOptionChange, handleSubmit }) => {
  const [buttonLoading, setButtonLoading] = useState(false)

  if (newsletters.length < 1) return <ErrorSection href='/' />

  return (
    <form
      className='flex flex-column gap-32 ai-center'
      onSubmit={e => {
        setButtonLoading(true)
        handleSubmit(e)
      }}
    >
      <div className='flex flex-column gap-16 jc-center ai-center'>
        <i className='w-56 h-56'>
          <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 56 56'>
            <rect width='56' height='56' fill='#F2F2F2' rx='28'></rect>
            <path fill='#0250C9' d='M14.99 21.139l12.33-7.392a1.333 1.333 0 011.372 0l12.317 7.393a.666.666 0 01.324.572v16.955A1.333 1.333 0 0140 40H16a1.334 1.334 0 01-1.334-1.333V21.71a.667.667 0 01.325-.572zm2.343 1.705v14.49h21.334V22.842l-10.662-6.4-10.672 6.4v.001zm10.747 7.42l7.061-5.95 1.718 2.04-8.76 7.382-8.947-7.373 1.696-2.059 7.232 5.96z'></path>
          </svg>
        </i>
        <h1 className='--prumo text-24 --font-bold text-center'>Seleccioná los Newsletters que querés seguir recibiendo.</h1>
      </div>
      <div className='flex flex-column gap-16 w-100'>
        <div className='flex flex-column'>
          {newsletters?.length > 1 && <NewsletterCardItem nombre='Seleccionar todos' id='all' checked={selectedOptions.length === newsletters.length} onChange={() => toggleSelectAll(newsletters)} />}
          {newsletters?.map((newsletter, i) => (
            <NewsletterCardItem key={i} onChange={e => handleOptionChange(e, newsletter)} checked={selectedOptions.includes(newsletter.id) || false} {...newsletter} />
          ))}
        </div>
        <p className='--arial text-14'>Si no seleccionás ninguno, dejarás de recibir todos los Newsletters.</p>
      </div>
      <Button label='CONFIRMAR SELECCIÓN' style={{ width: '100%', maxWidth: '21.75rem' }} type='submit' disabled={selectedOptions.length === 0} isLoading={buttonLoading} />
    </form>
  )
}

export default NewslettersForm

